import { ColumnDef } from '@tanstack/react-table'
import { Provider } from '@magnetar/admin-api-interfaces'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useViewModeActions } from '@/hooks/useViewModeActions'

export const columns: ColumnDef<Provider>[] = [
  {
    accessorKey: 'provider_id',
    header: 'ID',
    cell: ({ row }) => {
      const id: number = row.getValue('provider_id')
      return (
        <Badge variant="outline" className="font-medium">
          {id}
        </Badge>
      )
    },
  },
  {
    accessorKey: 'provider_code',
    header: '代碼',
  },
  {
    accessorKey: 'provider_name',
    header: '組織名稱',
  },
  {
    accessorKey: 'manager_name',
    header: '負責人',
  },
  {
    accessorKey: 'phone',
    header: '電話',
  },
  {
    accessorKey: 'email',
    header: 'Email',
    cell: ({ row }) => {
      const email: string | null = row.getValue('email')
      return email || '-'
    },
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      const is_active: boolean = row.getValue('is_active')
      return (
        <Badge variant={is_active ? 'default' : 'secondary'}>{is_active ? '啟用' : '停用'}</Badge>
      )
    },
  },
  {
    id: 'actions',
    cell: function ActionsCell({ row }) {
      const provider = row.original
      const { setProviderMode } = useViewModeActions()

      const handleEdit = () => {
        setProviderMode(provider.provider_id)
      }

      return (
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={handleEdit}>
            管理
          </Button>
        </div>
      )
    },
  },
]
